import { createReducer, on } from '@ngrx/store';
import * as ProductActions from './product.actions';

export interface ProductState {
  selectedProductListId: string | null;
  selectedCategoryId: string | null;
  selectedSubcategoryId: string | null;
}

export const initialProductState: ProductState = {
  selectedProductListId: null,
  selectedCategoryId: null,
  selectedSubcategoryId: null
};

export const productReducer = createReducer(
  initialProductState,
  on(ProductActions.setSelectedProductListId, (state, { productListId }) => ({
    ...state,
    selectedProductListId: productListId
  })),

  on(ProductActions.setSelectedCategoryId, (state, { categoryId }) => ({
    ...state,
    selectedCategoryId: categoryId
  })),
  on(ProductActions.setSelectedSubcategoryId, (state, { subcategoryId }) => ({
    ...state,
    selectedSubcategoryId: subcategoryId
  }))
);
